module.exports = "/assets/2260bba8e9064bd80cd37217c648192e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/booking-com.jpg
// module id = 613
// module chunks = 0